import React from 'react';

export const ByZyLogo = ({ className = '', style = {}, showTracer = false }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 400 400"
      className={className}
      style={style}
      fill="currentColor"
      aria-label="BY ZY Studio logo"
      role="img"
    >
      {showTracer && (
        <defs>
          <filter id="tracer-glow" x="-20%" y="-20%" width="140%" height="140%">
            <feGaussianBlur stdDeviation="2.2" result="blur" />
            <feComponentTransfer in="blur" result="dimBlur">
              <feFuncA type="linear" slope="0.5" />
            </feComponentTransfer>
            <feMerge>
              <feMergeNode in="dimBlur" />
              <feMergeNode in="SourceGraphic" />
            </feMerge>
          </filter>
        </defs>
      )}

      {/* Fill paths — original logo */}
      <g>
        <g>
          <g>
            <path d="M91.6,168.3c-15.74-.84-33.84,13.66-33.84,29.76s12.81,30.58,32.62,28.95c15.71-1.29,28.54-11.42,28.54-29.15,0-16.1-11.98-28.74-27.32-29.56ZM88.34,210.29c-7.07,0-12.81-5.66-12.81-12.64s5.74-12.64,12.81-12.64,12.81,5.66,12.81,12.64-5.74,12.64-12.81,12.64Z" />
            <path d="M57.88,146.67h17.22v49.33h-16.15c-.59,0-1.07-.48-1.07-1.07v-48.26h0Z" />
          </g>
          <path d="M144.97,202.15c3.31,10.99,21.25,10.99,23.29-.42l.47-32.75h17.2v60.21c-.95,21.88-30.31,28.4-48.25,21.06v-17.53c12.23,3.67,31.8,7.34,31.04-11.31-13,15.04-40.95-.63-40.95-17.61v-34.81l17.66.13" />
        </g>
        <path d="M301.28,202.34c3.31,10.99,21.25,10.99,23.29-.42l.47-32.75h17.2v60.21c-.95,21.88-30.31,28.4-48.25,21.06v-17.53c12.23,3.67,31.8,7.34,31.04-11.31-13,15.04-40.95-.63-40.95-17.61v-34.81l17.66.13" />
        <polygon points="226.56 169.11 274.2 169.11 274.2 185.11 245.31 210.7 276.71 211.11 276.71 225.79 224.16 225.79 224.16 210.3 252.65 184.61 226.56 185.01 226.56 169.11" />
      </g>
      <g>
        <path d="M225.64,245.49c-.4-.17-.71-.42-.93-.74s-.34-.69-.34-1.11h1.29c.03.32.15.58.38.78s.54.31.94.31.74-.1.98-.3c.23-.2.35-.46.35-.78,0-.25-.07-.45-.22-.6-.14-.16-.33-.28-.54-.36-.22-.08-.51-.18-.9-.28-.48-.13-.87-.26-1.17-.39-.3-.13-.56-.33-.77-.61-.21-.28-.32-.64-.32-1.1,0-.42.11-.79.32-1.11.21-.32.51-.56.89-.73s.82-.25,1.32-.25c.71,0,1.3.18,1.75.54.46.36.71.85.76,1.47h-1.34c-.02-.27-.15-.5-.38-.69-.23-.19-.54-.29-.92-.29-.35,0-.63.09-.85.26-.22.18-.33.43-.33.76,0,.23.07.41.21.56.14.15.31.26.52.34.21.08.5.18.87.28.49.13.88.27,1.19.4.31.13.57.34.78.62s.32.65.32,1.12c0,.37-.1.73-.3,1.06-.2.33-.49.6-.88.8-.39.2-.84.3-1.36.3-.49,0-.94-.09-1.34-.26Z" />
        <path d="M241.01,238.31v.99h-1.96v6.38h-1.21v-6.38h-1.97v-.99h5.14Z" />
        <path d="M248.72,238.31v4.69c0,.56.15.98.44,1.26.29.28.7.42,1.22.42s.94-.14,1.23-.42.44-.7.44-1.26v-4.69h1.21v4.67c0,.6-.13,1.11-.39,1.53-.26.42-.61.73-1.05.93-.44.21-.92.31-1.45.31s-1.01-.1-1.45-.31c-.43-.2-.78-.52-1.03-.93-.25-.42-.38-.93-.38-1.53v-4.67h1.21Z" />
        <path d="M264.6,238.76c.59.3,1.05.73,1.37,1.29.32.56.48,1.22.48,1.97s-.16,1.4-.48,1.95c-.32.55-.78.97-1.37,1.27-.59.29-1.28.44-2.06.44h-2.41v-7.37h2.41c.78,0,1.47.15,2.06.45ZM264.52,243.99c.46-.47.69-1.12.69-1.97s-.23-1.52-.69-2c-.46-.48-1.12-.72-1.98-.72h-1.2v5.39h1.2c.86,0,1.52-.23,1.98-.7Z" />
        <path d="M274.16,238.31v7.37h-1.21v-7.37h1.21Z" />
        <path d="M282.51,245.27c-.58-.32-1.03-.77-1.37-1.35s-.5-1.22-.5-1.94.17-1.37.5-1.94c.34-.57.79-1.02,1.37-1.34.58-.32,1.21-.48,1.89-.48s1.33.16,1.9.48c.58.32,1.03.77,1.36,1.34.33.57.5,1.22.5,1.94s-.17,1.37-.5,1.94c-.33.58-.79,1.02-1.36,1.35-.58.32-1.21.48-1.9.48s-1.32-.16-1.89-.48ZM285.71,244.36c.38-.22.68-.54.9-.95.22-.41.32-.89.32-1.44s-.11-1.02-.32-1.43c-.22-.41-.51-.72-.9-.94-.38-.22-.82-.33-1.3-.33s-.92.11-1.3.33c-.38.22-.68.53-.9.94-.22.41-.32.89-.32,1.43s.11,1.02.32,1.44c.22.41.51.73.9.95.38.22.82.33,1.3.33s.92-.11,1.3-.33Z" />
      </g>

      {/* Violet outline tracer — BYZY only (not STUDIO) */}
      {showTracer && (
        <g fill="none" filter="url(#tracer-glow)" strokeLinecap="round" strokeLinejoin="round">
          {/* B — outline + bar (same delay) */}
          <path className="logo-tracer-b" pathLength="1" d="M91.6,168.3c-15.74-.84-33.84,13.66-33.84,29.76s12.81,30.58,32.62,28.95c15.71-1.29,28.54-11.42,28.54-29.15,0-16.1-11.98-28.74-27.32-29.56ZM88.34,210.29c-7.07,0-12.81-5.66-12.81-12.64s5.74-12.64,12.81-12.64,12.81,5.66,12.81,12.64-5.74,12.64-12.81,12.64Z" />
          <path className="logo-tracer-b" pathLength="1" d="M57.88,146.67h17.22v49.33h-16.15c-.59,0-1.07-.48-1.07-1.07v-48.26h0Z" />
          {/* Y1 */}
          <path className="logo-tracer-y1" pathLength="1" d="M144.97,202.15c3.31,10.99,21.25,10.99,23.29-.42l.47-32.75h17.2v60.21c-.95,21.88-30.31,28.4-48.25,21.06v-17.53c12.23,3.67,31.8,7.34,31.04-11.31-13,15.04-40.95-.63-40.95-17.61v-34.81l17.66.13" />
          {/* Z (converted from polygon to path) */}
          <path className="logo-tracer-z" pathLength="1" d="M226.56,169.11L274.2,169.11L274.2,185.11L245.31,210.7L276.71,211.11L276.71,225.79L224.16,225.79L224.16,210.3L252.65,184.61L226.56,185.01Z" />
          {/* Y2 */}
          <path className="logo-tracer-y2" pathLength="1" d="M301.28,202.34c3.31,10.99,21.25,10.99,23.29-.42l.47-32.75h17.2v60.21c-.95,21.88-30.31,28.4-48.25,21.06v-17.53c12.23,3.67,31.8,7.34,31.04-11.31-13,15.04-40.95-.63-40.95-17.61v-34.81l17.66.13" />
        </g>
      )}
    </svg>
  );
};
